/* LocationBlock - utilities inline for map/address layout */
import { contentBlockClassName } from '../../ContentBlockStyles';

export const locationBlockClassName = contentBlockClassName;
